<template>
  <McButton
    variant="secondary"
    :text="$t('global.back')"
    icon="icon-outline_arrow-left"
    @click="goBack"
  />
</template>
<script>
import McButton from '@/components/McButton'
import { MixPanel } from '@/mixin/mixpanel'
export default {
  components: {
    McButton,
  },
  mixins: [MixPanel],
  props: {
    href: {
      type: String,
      default: '',
      required: false,
    },
    query: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goBack() {
      this.track('On Page Back Button')
      if (this.href) {
        const options = {
          path: this.href,
        }
        if (this.query) {
          options.query = this.query
        }
        return this.$router.push(options).catch(() => {})
      }

      return this.$router.go(-1)
    },
  },
}
</script>
